import Reveal from "@/components/Reveal";

const chapters = [
  {
    num: "01",
    title: "We listen before we answer.",
    body: "Every engagement starts inside your business — your product, your customers, your voice. Agents go live only after they're certified on your brand, not a generic script.",
  },
  {
    num: "02",
    title: "We train like it's our name on the line.",
    body: "Rigorous onboarding, ongoing coaching and QA scoring on real interactions. Because to your customers, we are you — and we take that personally.",
  },
  {
    num: "03",
    title: "We report everything.",
    body: "Live dashboards, weekly reviews and brutal honesty about the numbers. You'll never wonder what your outsourced team did this week. You'll already know.",
  },
];

const Manifesto = () => (
  <section id="why-us" data-testid="manifesto-section" className="py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-sky-400 md:text-sm">
          02 — Why Future Solutions
        </p>
      </Reveal>

      <div className="mt-8 space-y-0">
        {chapters.map((c, i) => (
          <Reveal
            key={c.num}
            delay={i * 0.05}
            className={`grid gap-6 border-t border-white/10 py-14 md:grid-cols-12 md:gap-10 md:py-20 ${
              i === chapters.length - 1 ? "border-b" : ""
            }`}
          >
            <div className="md:col-span-4">
              <span
                data-testid={`manifesto-number-${c.num}`}
                className="font-display text-7xl font-black tracking-tighter text-transparent md:text-9xl"
                style={{ WebkitTextStroke: "1.5px rgba(125,211,252,0.6)" }}
              >
                {c.num}
              </span>
            </div>
            <div className={i % 2 === 1 ? "md:col-span-6 md:col-start-6" : "md:col-span-6"}>
              <h3 className="font-display text-3xl font-bold tracking-tight md:text-5xl">{c.title}</h3>
              <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 md:text-lg">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
